import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { staffAgreementsOptions } from "./staffAgreementOptions";
import { NotesComponent } from "../../components/notes/NotesComponent";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { staffWeeklyHoursOptions } from "../staff-weekly-hours/staffWeeklyHoursOptions";
import { tabs } from "./staffAgreementsTabs";
import { fieldsQuery as staffWeeklyHoursFieldsQuery } from "../staff-weekly-hours/staffWeeklyHoursRoutes";
import { staffRemunerationOptions } from "../staff-remunerations/staffRemunerationOptions";

export const fieldsQuery = "*.*";

export const staffAgreementsRoutes = [
    {
        path: "/staff_agreements",
        element: (
            <Records entity="staff_agreements" fieldsQuery={fieldsQuery} options={staffAgreementsOptions} heightOfHeaders={190} />
        ),
    },
    {
        path: "/staff_agreements/:id",
        element: <Record entity="staff_agreements" type="detail" fieldsQuery={fieldsQuery} body={<DetailTabs tabs={tabs} />} />,
        children: [
            {
                path: "/staff_agreements/:id/detail",
                element: <Groups groupsOptions={staffAgreementsOptions?.groupsOptions} />,
            },
            {
                element: <NotesComponent />,
                path: "/staff_agreements/:id/notes",
            },
            {
                element: (
                    <RecordsRelated
                        entity={"staff_weekly_hours"}
                        fieldsToQuery={staffWeeklyHoursFieldsQuery}
                        fieldToFilter="staff_agreement"
                        recordsOptions={staffWeeklyHoursOptions}
                        heightOfHeaders={190}
                    />
                ),
                path: "/staff_agreements/:id/staff_weekly_hours",
            },
            {
                element: (
                    <RecordsRelated
                        entity={"staff_remuneration"}
                        fieldsToQuery={"*.*"}
                        customFilter={(params) => {
                            return {
                                operations_staff_agreement_id: {
                                    _eq: params.parentId,
                                },
                            };
                        }}
                        recordsOptions={staffRemunerationOptions}
                        heightOfHeaders={190}
                    />
                ),
                path: "/staff_agreements/:id/staff_remuneration",
            },
        ],
    },
    {
        path: "/staff_agreements/:id/update",
        element: (
            <Record
                entity="staff_agreements"
                type="update"
                body={<EntityForm groupsOptions={staffAgreementsOptions?.groupsOptions} />}
            />
        ),
    },
    {
        path: "/staff_agreements/create",
        element: (
            <Record
                entity="staff_agreements"
                type="create"
                body={<EntityForm groupsOptions={staffAgreementsOptions?.groupsOptions} />}
            />
        ),
    },
];
